import React from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { decodeId } from '../utils/urlSecurity';

const Submitted = () => {
  const { encodedSubmissionId } = useParams();
  const location = useLocation();
  const navigate = useNavigate();
  const formData = location.state?.formData;
  
  // Decode the submission ID from the URL parameter (for future use)
  // eslint-disable-next-line no-unused-vars
  const submissionId = decodeId(encodedSubmissionId);

  return (
    <div className="max-w-2xl mx-auto p-5">
      <div className="bg-white/10 backdrop-blur-sm border border-white/20 rounded-xl max-w-lg mx-auto mt-8 text-center">
        <div className="p-12">
          {/* Success Icon */}
          <div className="mb-8">
            <div className="w-20 h-20 bg-green-500 rounded-full mx-auto flex items-center justify-center text-4xl text-white shadow-lg">
              ✓
            </div>
          </div>

          {/* Title */}
          <h1 className="text-green-400 text-4xl font-bold mb-6">
            Survey Submitted Successfully!
          </h1>

          {/* Main Message */}
          <div className="mb-8">
            <p className="text-xl leading-relaxed text-white mb-4">
              Your survey has been submitted and your results are being reviewed and will be sent via email.
            </p>
            <p className="text-lg text-gray-200 mb-4">
              Please wait. Thank you for staying with us!
            </p>
          </div>

          {/* Opportunity Info */}
          {formData?.email && (
            <div className="bg-white/10 border border-white/20 p-4 rounded-lg mb-8 text-left">
              <h3 className="text-white font-medium mb-2">
                Your AI Opportunity Assessment:
              </h3>
              <p className="text-gray-300 mb-2">
                Your opportunity has been submitted and a descriptive name will be generated automatically.
              </p>
              <p className="text-sm text-gray-300">
                Results will be sent to: {formData.email}
              </p>
            </div>
          )}

          {/* Action Buttons */}
          <div className="mb-4">
            <button
              onClick={() => navigate('/')}
              className="px-8 py-3 bg-gradient-to-r from-blue-500 to-purple-600 text-white rounded-lg font-medium text-lg hover:shadow-lg transition-all duration-200 hover:scale-105"
            >
              Take Another Survey
            </button>
          </div>

          {/* Completion notice */}
          <p className="text-green-300 font-medium mt-4">
            ✅ Your assessment has been completed and recorded!
          </p>
        </div>
      </div>
    </div>
  );
};

export default Submitted;